import { brandingLineMeasure } from '../../../../shared/contracts/branding-line.js';
import { unitLabel } from '../../../../shared/contracts/unit-label.js';

/** An order line as screens hold it: its measure, and a size for area work. */
export interface OrderLineQuantity {
  readonly uomCode: string;
  readonly dim1: string | number | null;
  readonly dim2: string | number | null;
}

type Decimal = (v: string | number | null | undefined) => string;

/**
 * What an order line asks for. The line holds its measure in its unit (the
 * area of a wall, the square feet of an ad); an area line shows the pieces
 * and size it comes from, "1 × 2 × 5 = 10 Sq Ft", read through the shared
 * contract the bill's description is built from. Counted and broadcast lines
 * read "3 Spot".
 */
export function orderLineQuantityLabel(
  l: OrderLineQuantity,
  measured: string | number,
  decimal: Decimal,
): string {
  const dim1 = Number(l.dim1 ?? 1);
  const dim2 = Number(l.dim2 ?? 1);
  const m = brandingLineMeasure(
    { quantity: Number(measured) / (dim1 * dim2), dim1, dim2, dim3: null, rateValue: 0 },
    { uomName: unitLabel(l.uomCode), dim3UomName: null },
  );
  return m.shape === 'AREA'
    ? `${decimal(m.count)} \u00d7 ${decimal(dim1)} \u00d7 ${decimal(dim2)} = ${decimal(
        m.measured,
      )} ${m.measuredUnit}`
    : `${decimal(m.count)} ${m.countUnit}`;
}
